import type { SalesChecklistItem } from "@expert/contentful";

/**
 * The subset of checklist items that render a countable bullet. An item whose `phrase` AND
 * `subheading` are both blank (e.g. a cohort override that drops the bullet while keeping its example
 * carousel) renders `null` via `ChecklistItem`, so it can never be detected/checked. Counting it toward
 * completion would leave the section permanently incomplete — exclude it. Normal items are unaffected
 * (for a section with no blanked items this is a no-op), and the excluded item still renders (carousel
 * included) because the section maps over the full visible list, not this one.
 */
export const getCompletableItems = (checklistItems: SalesChecklistItem[]): SalesChecklistItem[] =>
    checklistItems.filter((item) => Boolean(item.phrase) || Boolean(item.subheading));
